import React from 'react';
import tw from 'twin.macro';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'gatsby-plugin-intl';
import { capitalizeFirstLetter } from '@utils/helpers';

import Text from '@components/text';
import { Link } from 'gatsby';
import ArrowDefault from '@images/arrow.svg';
import BlockSanity from '@components/block-sanity';
import Date from '@components/date';

const Wrapper = tw.div`mb-55 md:flex md:items-center`;

const LinkImage = tw(Link)`block mb-10 md:w-1/2 md:mr-30 md:mb-0`;

const TagWrapper = tw.div`flex flex-wrap -mt-5 mb-12`;

const LinkTag = tw(Link)`mr-5 pt-5 transition-opacity duration-300 hover:opacity-80`;

const LinkTitle = tw(Link)`inline-block mb-8 md:mb-15`;

const PostDate = tw(Text)`flex items-center mb-15 opacity-63 md:mb-30`;

const Dot = tw.div`w-3 h-3 mx-15 rounded-full bg-primary`;

const PostContent = tw.div`pr-30 md:w-1/2`;

const CTA = tw(Link)`flex items-center mt-20 md:mt-30`;

const Arrow = tw(ArrowDefault)`w-22 ml-15`;

const Post = ({ post, locale }) => {
  const isEnglish = locale === 'en';
  const pagePath = isEnglish ? '/en/post/' : '/post/';
  const postPath = `${pagePath}${post[`slug_${locale}`].current}`;

  const pathPart = locale === 'en' ? '/en/tag/' : '/tag/';
  const pathTo = (path) => `${pathPart}${path}`;

  return (
    <Wrapper>
      <LinkImage to={postPath}>
        <Img fluid={post.mask_big.asset.fluid} />
      </LinkImage>
      <PostContent>
        <TagWrapper>
          {post.post_tags.map((tag) => (
            <LinkTag key={tag.name_en} to={pathTo(tag[`slug_${locale}`].current)}>
              <Text color="blueDark" fontSizes={14} letterSpacing={9}>
                {tag[`name_${locale}`]}
              </Text>
            </LinkTag>
          ))}
        </TagWrapper>
        <LinkTitle to={postPath}>
          <Text fontFamily="bebasNeue" fontSizes={36} fontWeight={700} letterSpacing={45}>
            {post[`title_${locale}`]}
          </Text>
        </LinkTitle>
        <PostDate fontSizes={14} letterSpacing={18}>
          <Date locale={locale} date={post.date} />
          <Dot />
          <span>{post.author.name}</span>
        </PostDate>
        <Text fontSizes={16} fontWeight={300} lineHeight={1.4} letterSpacing={20}>
          <BlockSanity content={post[`_rawPostPreview${capitalizeFirstLetter(locale)}`]} noSpacing />
        </Text>
        <CTA to={postPath}>
          <Text fontSizes={16} fontWeight={600} letterSpacing={20} uppercase underline>
            <FormattedMessage id="btn.see post" />
          </Text>
          <Arrow />
        </CTA>
      </PostContent>
    </Wrapper>
  );
};

Post.propTypes = {
  post: PropTypes.objectOf(
    PropTypes.any,
  ).isRequired,
  locale: PropTypes.string.isRequired,
};

export default Post;
